(function (root, factory) {
	'use strict';

	if (typeof define === 'function' && define.amd) {
		// AMD
		define(['components/utilities/utilities'], factory);
	} else if (typeof exports === 'object') {
		// Node, CommonJS-like
		module.exports = factory(require('components/utilities/utilities'));
	} else {
		// Browser globals (root is window)
		root.s5STabUsability = factory(root.s5Utils);
	}
}(this, function (utils) {
	'use strict';

	/**
	 * Tab usability
	 * This plugin adds a class to elements when they have tabfocus, which allows styling without the style applying to the :active state.
	 * @version 2.0.5
	 * @exports tabUsability
	 */
	var tabUsability = {

		/**
		 * The initialization function for this module.
		 * @public
		 */
		init: function () {
			this._initEvents();
		},


		/**
		 * Initiates events.
		 * @private
		 */
		_initEvents: function () {
			utils.addEventListener(document, 'keyup', function (event) {
				var el = event.target,
					keyCode = event.keyCode ? event.keyCode : event.which;

				if (['a', 'button', 'input', 'textarea', 'select'].indexOf(el.tagName.toLowerCase()) !== -1 && keyCode === 9) {
					utils.addClass(el, 'tab-focus');
				}
			});

			utils.addEventListener(document, 'click', function (event) {
				var el = event.target;

				if (['input', 'textarea'].indexOf(el.tagName.toLowerCase()) !== -1) {
					utils.addClass(el, 'tab-focus');
				}
			});

			utils.addEventListener(document, 'blur', function (event) {
				var el = event.target;

				if (utils.hasClass(el, 'tab-focus')) {
					utils.removeClass(el, 'tab-focus');
				}
			});
		}
	};


	return tabUsability;
}));